import React, { useEffect, useState } from "react";
import axios from "axios";
import * as Constants from "../../constants/urls";
import { useCookies } from "react-cookie";
import { Link } from "react-router-dom";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import HomepageClassEditModal from "./HomepageClassEditModal";

export default function HomepageClass() {
    const [data, setData] = useState(undefined);
    const [modal, setModal] = useState(false);
    const [classId, setClassId] = useState(false);
    const [cookies, setCookie, removeCookie] = useCookies();

    useEffect(() => {
        getData();
    }, [])
    function getData() {

        const url = Constants.apiUrl + "/api/homepage/class";
        axios.get(url, {
            headers: {
                Authorization: "Bearer " + cookies.user_server_token,
            },
        })
            .then((r) => {
                setData(r.data.data);
            })
            .catch((e) => {

            });
    } 

    return (<>
        {modal && <HomepageClassEditModal ids={classId} cancle={() => { setModal(false) ;getData() }} />}
        <Breadcrumb title={" ویرایش کلاس های صفحه اصلی"} />

        <div className="table-responsive mt-5 mb-5">
            <table className="table table-striped table-hover">
                <tr>
                    <td>شناسه کلاس</td>
                    <td> ویرایش  </td>
                </tr>
                {
                    data && data.map((item) => {
                        return <tr>
                            <td>{item.class_id}</td>
                            <td>
                                <button className="btn btn-warning" onClick={() => { setModal(true); setClassId(item.id) }}>ویرایش</button>
                            </td>
                        </tr>
                    })
                }
            </table>
        </div>
    </>)
}